import { COOKIE_KEY } from '@zmedia/bm-soccer-ui/constants';
import { IAuthState } from '@zmedia/bm-soccer-ui/interface';
import AuthService from '@zmedia/bm-soccer-ui/service/AuthService';
import CookieStore from '@zmedia/bm-soccer-ui/utils/cookie';
import { fireTracking } from '@zmedia/bm-soccer-ui/utils/tracking';

export const AUTH_SET_STATE = 'AUTH_SET_STATE';
export const AUTH_IS_FETCHING_UPDATE = 'AUTH_IS_FETCHING_UPDATE';
export const AUTH_CLEAR_STATE = 'AUTH_CLEAR_STATE';

export const setAuthState = (authState: IAuthState) => ({
    type: AUTH_SET_STATE,
    payload: authState,
});

export const clearAuthState = () => ({
    type: AUTH_CLEAR_STATE,
});

export const isFetchingUpdate = (isFetching: boolean) => ({
    type: AUTH_IS_FETCHING_UPDATE,
    payload: isFetching,
});

export function auth() {
    return (dispatch: any) => {
        dispatch(isFetchingUpdate(true));
        AuthService.auth()
            .then((resp) => {
                if (resp.data) {
                    (window as any).dataAuth = resp.data;
                    dispatch(setAuthState(resp.data));
                    const isClickBtn = CookieStore.get(
                        COOKIE_KEY.BM_CLICK_LOGIN
                    ) as boolean;
                    if (resp.data.userId > 0 && isClickBtn) {
                        const isMobile = (window as any)._BM.isMobile;
                        const key = isMobile ? 'wap' : 'web';
                        fireTracking('/log', {
                            key: key + '_consent_privacy',
                            uid: resp.data.strUserId,
                        });
                        fireTracking('/log', {
                            key: key + '_consent_tou',
                            uid: resp.data.strUserId,
                        });
                        CookieStore.remove(COOKIE_KEY.BM_CLICK_LOGIN);
                    }
                }
            })
            .finally(() => {
                dispatch(isFetchingUpdate(false));
            });
    };
}

export function login() {
    return (dispatch: any) => {
        dispatch(isFetchingUpdate(true));
        AuthService.auth()
            .then((resp) => {
                if (resp.data) {
                    dispatch(setAuthState(resp.data));
                }
            })
            .finally(() => {
                dispatch(isFetchingUpdate(false));
            });
    };
}

export function logout() {
    return (dispatch: any) => {
        dispatch(isFetchingUpdate(true));
        AuthService.logout()
            .then((resp) => {
                window.location.replace(window.location.href);
                if (resp.data) {
                    dispatch(clearAuthState());
                }
            })
            .finally(() => {
                dispatch(isFetchingUpdate(false));
            });
    };
}
